import { AnyAction, Dispatch } from 'redux';

import { CategoriesApiService, IGetCategoriesParams } from '@ClientApi/categories';
import { ICompanyCategoryModel } from '@Shared/models';

export const ADD_CATEGORIES = 'ADD_CATEGORIES';
export const SET_CATEGORIES_LOADING = 'SET_CATEGORIES_LOADING';
export const CATEGORIES_ADD_CATEGORIES_FOR_USER = 'CATEGORIES_ADD_CATEGORIES_FOR_USER';

export class AddCategories {
  readonly type = ADD_CATEGORIES;
  constructor(public categories: ICompanyCategoryModel[]) {}
}

export class SetCategoriesLoading {
  readonly type = SET_CATEGORIES_LOADING;
  constructor(public payload: boolean) {}
}

export class AddCategoriesForUser {
  readonly type = CATEGORIES_ADD_CATEGORIES_FOR_USER;
  payload: {
    userId: string;
    categories: ICompanyCategoryModel[];
  };
  constructor(userId: string, categories: ICompanyCategoryModel[]) {
    this.payload = { userId, categories };
  }
}

export const getCategories =
  (dispatch: Dispatch<AnyAction>) =>
  async (params: IGetCategoriesParams = {}) => {
    dispatch(new SetCategoriesLoading(true));
    const categories = await CategoriesApiService.getCategories(params);
    dispatch(new AddCategories(categories));
    dispatch(new SetCategoriesLoading(false));

    return categories;
  };

export type CategoriesAction = AddCategories | SetCategoriesLoading | AddCategoriesForUser;
